<template>
  <section
    class="padding_large vimeo-module-blocks"
    :class="{ 'bg-gray': data.gray_background }"
  >
    <ModuleContainer
      v-observe-visibility="visibilityChanged"
      :class="[baseAnimation]"
    >
      <ModuleHeading :level="2">{{ data.module_title }}</ModuleHeading>
      <div
        class="module-description"
        v-if="data.moduel_description"
        v-html="data.moduel_description"
      ></div>

      <div
        v-observe-visibility="canYouSeeMee"
        class="vimeo-blocks-row"
        v-if="vimeoData && vimeoData.length && total > 0"
      >
        <div class="vimeo-block" v-for="(vimeo, k) in vimeoData" :key="k">
          <div class="video-header">
            <div
              class="bg-vimeo"
              :ref="'placehold_' + k"
              @click="playVideo(k)"
              :style="'background-image:url(' + getVideoImage(vimeo) + ')'"
            />
            <div
              class="video-embed"
              :ref="'video_' + k"
              v-html="vimeo.embed.html"
            ></div>
          </div>

          <h4 class="titler">{{ vimeo.name }}</h4>
          <div
            class="descr"
            v-if="vimeo.description"
            v-html="vimeo.description"
          ></div>
        </div>
      </div>

      <div
        class="perloader-container"
        v-show="isLoading"
        v-html="svgIcons.preloader"
      />

      <div
        :class="{ 'is-working': isLoading }"
        class="load-more"
        v-if="total > 0 && total > vimeoData.length"
      >
        <button @click="loadVideos" class="showMe btn btn-primary">
          <span class="icon" v-html="svgIcons.load"> </span>
          <span class="text">Last inn flere</span>
        </button>
      </div>
    </ModuleContainer>
  </section>
</template>

<script>
import Player from "@vimeo/player";

export default {
  name: "vimeo-gallery",
  props: ["data"],
  data() {
    return {
      players: {},
      isLoading: false,
      vimeoData: [],
      nextPage: 1,
      total: 0,
      perPage: 3
    };
  },
  mounted() {
    this.loadVideos();
  },
  destroyed() {
    const VM = this;
    const size = Object.keys(VM.players).length;
    if (size) {
      Object.keys(VM.players).forEach(key => {
        VM.players[key].destroy();
      });
    }
  },
  methods: {
    getVideoImage(video) {
      const image = video.pictures.sizes.filter(
        i => i.width > 900 && i.width < 1100
      );
      return image && image[0] && image[0].link_with_play_button
        ? image[0].link_with_play_button
        : false;
    },
    canYouSeeMee(isMe) {
      if (!isMe) {
        this.pauseAllPlaying();
      }
    },
    pauseAllPlaying(except = "") {
      const VM = this;
      const size = Object.keys(VM.players).length;
      if (size) {
        Object.keys(VM.players).forEach(key => {
          if (key !== except) VM.players[key].pause();
        });
      }
    },
    playVideo(id) {
      const placeholdID = "placehold_" + id;

      const player_ID = "video_" + id;
      const VM = this;
      let player = VM.players[player_ID];
      if (!player) {
        const el = VM.$refs[player_ID];
        VM.$refs[placeholdID][0].classList.add("is-activated");
        if (!el[0]) return;
        const iframe = el[0].querySelector("iframe");
        player = new Player(iframe);
        VM.players[player_ID] = player;
      }
      const size = Object.keys(VM.players).length;
      if (size) {
        VM.players[player_ID].on("play", () => {
          VM.pauseAllPlaying(player_ID);
        });

        VM.players[player_ID].play();
      }
      player.play();
    },
    async loadVideos() {
      if (this.isLoading) return null;
      this.isLoading = true;
      return await this.$axios("wpvue/v2/vimeo", {
        params: {
          id: Number(this.data.select_gallery),
          page: this.nextPage
        }
      }).then(e => {
        if (e && !e.data.error && e.data.data) {
          this.nextPage = e.data.page + 1;
          if (this.total !== e.data.total) this.total = e.data.total;
          this.vimeoData = [...this.vimeoData, ...e.data.data];
        } else {
          console.warn("Error", e);
        }
        this.isLoading = false;
        return e;
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/mixins.scss";
@import "@/assets/scss/vars.scss";

.vimeo-module-blocks {
  .module-description {
    font-weight: 300;
    font-size: 16px;
    margin-bottom: 35px;
    max-width: 650px;
    @include mquery(767px) {
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
  .vimeo-blocks-row {
    display: flex;
    flex-wrap: wrap;
    margin: -12px;
    overflow: hidden;
    .bg-vimeo {
      position: absolute;
      z-index: 6;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
      cursor: pointer;
      &.is-activated {
        display: none;
      }
    }

    .vimeo-block {
      width: 33.33%;
      min-width: 33.33%;
      padding: 12px;
      position: relative;
      @include mquery(767px) {
        width: 50%;
        min-width: 50%;
      }
      @include mquery(460px) {
        width: 100%;
        min-width: 100%;
      }
      .titler {
        margin-top: 15px;
        font-size: 20px;
        margin-bottom: 5px;
        @include mquery(767px) {
          font-size: 18px;
          margin-top: 10px;
        }
        @include mquery(460px) {
          font-size: 16px;
        }
      }
      .descr {
        font-weight: 300;
        font-size: 14px;
      }
    }
  }
  .perloader-container {
    margin: 15px auto;
    text-align: center;
  }
  .load-more {
    margin-top: 25px;
    text-align: center;
    @include mquery(767px) {
      margin-top: 15px;
    }
    &.is-working {
      button {
        opacity: 0.6;
        pointer-events: none;
      }
    }
  }
  .video-header {
    position: relative;
  }
  .video-embed {
    position: relative;
    padding-bottom: 62.53%;
    height: 0;
    background-color: #d8d8d8;

    iframe {
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
}
</style>
